import Stylus from './Stylus';
import PanBrush from './PanBrush';

// Canvas panning stylus
class StylusPan extends Stylus {
  activate() {
    const brush = new PanBrush({ canvas: this.controller.canvas });
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  cursor() {
    return 'grab';
  }
}

export default StylusPan;
